<mat-card style="border-color: #5775a8;">
  <mat-card-header class="">
    <div class="flex flex-row rounded-lg w-full" style="background-color:#5775a8; padding: 20px;">
      <mat-icon style="color: white;">search</mat-icon>
      <span style="font-size: large; color: white;">
        Search Complaints
      </span>
    </div>
  </mat-card-header>

  <mat-card-content>
    <div class="flex flex-col">
      <br />
      <form [formGroup]="form">
        <div class="flex flex-row rounded-lg w-full justify-evenly">
          <mat-form-field class="container">
            <mat-label>Search Text</mat-label>
            <input matInput formControlName="searchText" placeholder="Enter search text here"
                (keyup.enter)="getSearchData()">
            <mat-error *ngIf="form.get('searchText').invalid">
              This field is required (50 char max)
            </mat-error>
          </mat-form-field>

          <mat-form-field class="container">
            <mat-label>County</mat-label>
            <mat-select formControlName="countyId">
              <mat-option *ngIf="countyList.length > 0" value="All" selected>All Counties</mat-option>
              <mat-option *ngFor="let list of countyList" [value]="list.value">
                {{list.text}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="container">
            <mat-label>Start Date</mat-label>
            <input matInput [matDatepicker]="startDate" formControlName="startDate">
            <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
            <mat-datepicker #startDate></mat-datepicker>
            <mat-error *ngIf="form.get('startDate').invalid">
              Invalid Date.
            </mat-error>
          </mat-form-field>

          <mat-form-field class="container">
            <mat-label>End Date</mat-label>
            <input matInput [matDatepicker]="endDate" formControlName="endDate">
            <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
            <mat-datepicker #endDate></mat-datepicker>
            <mat-error *ngIf="form.get('endDate').invalid">
              Invalid Date.
            </mat-error>
          </mat-form-field>
        </div>
      </form>
      <div>
        <button mat-raised-button (click)="getSearchData()" class="m-8" style="background: #7ABDF3;">
          <mat-icon>search</mat-icon>
          Search
        </button>
        </div>
    </div>

    <div *ngIf="showList" class="flex flex-col w-full">
      <div class="flex flex-row rounded-lg w-full pannel-heading" style="background-color:#5775a8; padding: 20px;">
        <span class="flex flex-row w-1/2" style="font-size: large; color: white;">
          Results ({{resultsCount}})
        </span>
        <span class="flex flex-row w-1/2 justify-end" style="color:white;">
          *<span style="color: red;">Red</span> &nbsp;= unverified complaints
        </span>
      </div>

      <div class="flex flex-col w-full" *ngIf="showList" style="overflow-x:auto;">
        <div class="flex flex-row w-full">
          <button mat-raised-button (click)="download()" class="m-8" color="accent">
            <mat-icon>printer</mat-icon>
            CSV
          </button>
          <div class="flex flex-row w-full justify-end">
            <!-- <div class="w-30 lg:w-full"> -->
              <input (keyup)="filterTable($event)" placeholder="Search" [value]="filter" />
            <!-- </div> -->
          </div>
        </div>
        <div class="flex flex-row w-full">
  
          <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort" class="w-full">
  
            <ng-container matColumnDef="complaintId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint ID</th>
              <td mat-cell *matCellDef="let complaint">
                <a *ngIf="complaint.businessName == null" (click)="gotoUnverified(complaint.complaintId, complaint.businessId)">{{complaint.complaintId}}</a>
                <a *ngIf="complaint.businessName != null" (click)="gotoComplaint(complaint.complaintId)">{{complaint.complaintId}}</a>
              </td>
            </ng-container>
            <ng-container matColumnDef="businessName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Business Name</th>
              <td mat-cell *matCellDef="let complaint">
                <a *ngIf="complaint.businessName == null" style="color: red;" (click)="gotoUnverified(complaint.complaintId, complaint.businessId)">{{complaint.initialComplaint.businessName}}</a>
                <a *ngIf="complaint.businessName != null" (click)="gotoBusiness(complaint.businessId)">{{complaint.businessName}}</a>
              </td>
            </ng-container>
            <ng-container matColumnDef="address">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
              <td mat-cell *matCellDef="let complaint">
                <span *ngIf="complaint.businessName == null" style="color: red;">
                  {{complaint.initialComplaint.address}}
                </span>
                <span *ngIf="complaint.businessName != null">
                  {{complaint.address}}
                </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="city">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
              <td mat-cell *matCellDef="let complaint">
                <span *ngIf="complaint.businessName == null" style="color: red;">
                  {{complaint.initialComplaint.city}}
                </span>
                <span *ngIf="complaint.businessName != null">
                  {{complaint.city}}
                </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="zip">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Zip</th>
              <td mat-cell *matCellDef="let complaint">
                <span *ngIf="complaint.businessName == null" style="color: red;">
                  {{complaint.initialComplaint.zip}}
                </span>
                <span *ngIf="complaint.businessName != null">
                  {{complaint.zip}}
                </span>
              </td>
            </ng-container>
  
            <ng-container matColumnDef="complaintDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint Date</th>
              <td mat-cell *matCellDef="let complaint">
                <span *ngIf="complaint.businessName == null" style="color: red;">
                  {{complaint.complaintDate}}
                </span>
                <span *ngIf="complaint.businessName != null">
                  {{complaint.complaintDate}}
                </span>
              </td>
            </ng-container>
  
            <ng-container matColumnDef="reasonNonActionable">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Reason Non-Actionable</th>
              <td mat-cell *matCellDef="let complaint">
                <span *ngIf="complaint.businessName == null" style="color: red;">
                  {{complaint.reasonNonActionable}}
                </span>
                <span *ngIf="complaint.businessName != null">
                  {{complaint.reasonNonActionable}}
                </span>
              </td>
            </ng-container>
  
            <ng-container matColumnDef="complaintStatus">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint Status</th>
              <td mat-cell *matCellDef="let complaint">
                <span *ngIf="complaint.businessName == null" style="color: red;">
                  {{complaint.complaintStatus}}
                </span>
                <span *ngIf="complaint.businessName != null">
                  {{complaint.complaintStatus}}
                </span>
              </td>
            </ng-container>
  
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>
  
          </table>
        </div>
        <mat-paginator [pageSizeOptions]="[5, 20, 100]" #TablePaginator="matPaginator" 
          showFirstLastButtons></mat-paginator>
      </div>
  
    </div>

    <div fxLayout="column">
      <div class="flex flex-row sm:flex-row">

      </div>

    </div>

  </mat-card-content>
</mat-card>
<!-- 
<img src="../../../assets/images/translucentOhaLogo.png" class="bg hideOnMobile" alt="Oregon Health Authority Logo"
  aria-label="Oregon Health Authority Logo">

<img src="../../../assets/images/translucentOhaLogo.png" class="bg-mobile showOnMobile"
  alt="Oregon Health Authority Logo" aria-label="Oregon Health Authority Logo">
 -->
